import { render, staticRenderFns } from "./PublishVideo.vue?vue&type=template&id=833d5446&scoped=true"
import script from "./PublishVideo.vue?vue&type=script&lang=js"
export * from "./PublishVideo.vue?vue&type=script&lang=js"
import style0 from "./PublishVideo.vue?vue&type=style&index=0&id=833d5446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833d5446",
  null
  
)

export default component.exports